import React, { useState, useEffect } from 'react';
import Accordion from '@salesforce/design-system-react/components/accordion';
import AccordionPanel from '@salesforce/design-system-react/components/accordion/panel';
import IconSettings from '@salesforce/design-system-react/components/icon-settings';
import Dropdown from '@salesforce/design-system-react/components/menu-dropdown';
import { useNavigate } from 'react-router-dom';
import { getDateTimeFromTimestampAltFromat } from '../../../utilities/datetime';
import { getFirstandLastPartString } from '../../../utilities/account';
import { capitalizeFirstLetter } from '../../../utilities/string';
import { getChainInfo } from '../../../utilities/chain';
import { getSubParts } from '../../../utilities/getSubParts';
import WalletAddressEllipsis from '../../../components/shared/WalletAddressEllipsis';
import { Button } from '@salesforce/design-system-react';

const Transaction = (props) => {
  const [items, setItems] = useState(props?.transactions);

  useEffect(() => {
    if (props?.transactions) {
      setItems(props?.transactions);
    }
  }, [props?.transactions]);

  const navigateToTransaction = (e) => {
    e.stopPropagation();
    navigate(`/defi/transactions`);
  };

  const [expandedPanels, setExpandedPanels] = useState({});
  const navigate = useNavigate();

  const menuDropdown = (selectedItem) => {
    return (
      <Dropdown
        align="right"
        id={selectedItem.tx_hash}
        assistiveText={{ icon: 'More Options' }}
        buttonVariant="icon"
        buttonClassName="slds-shrink-none"
        iconCategory="utility"
        iconName="down"
        iconVariant="border-filled"
        onSelect={(option) => {
          if (option.label === 'View details') {
            navigate(`/transaction/${selectedItem.tx_hash}`);
          }
        }}
        options={[
          {
            label: 'View details',
            value: 'A0',
          },
        ]}
        iconSize="x-small"
      />
    );
  };

  const togglePanel = (event, data) => {
    setExpandedPanels({
      [data.tx_hash]: !expandedPanels[data.tx_hash],
    });

    if (props.action) {
      const dataAsArray = Object.keys(data).map((id) => data[id]);
      props.action('onClick')(event, ...dataAsArray);
    }
  };

  const detailTransaction = (id) => {
    navigate(`/transaction/${id}`);
  };

  // render() {
  return (
    <div
      className="home_card home_transaction defi_transaction defi_card"
      style={{ overflowX: 'scroll', overflowY: 'hidden' }}
    >
      <div
        style={{
          height: '100%',
          paddingRight: '0px',
          minWidth: '580px',
        }}
      >
        <p className="heading_text" style={{ paddingBottom: '0.5rem' }}>
          Transactions
        </p>
        {(items || []).length ? (
          <IconSettings iconPath="/assets/icons">
            <Accordion id="base-example-accordion">
              {items?.map((item, i) => {
                return (
                  <AccordionPanel
                    expanded={expandedPanels[item.tx_hash]}
                    id={item.tx_hash}
                    panelContentActions={menuDropdown(item)}
                    key={item.id}
                    title={item?.name || 'Transaction'}
                    onTogglePanel={(event) => togglePanel(event, item)}
                    summary={
                      <div
                        style={{
                          display: 'flex',
                          // flexWrap: 'wrap',
                          // rowGap: '10px',
                        }}
                        className="defi-overview-transaction-item"
                      >
                        <div style={{ display: 'flex', width: '24ch' }}>
                          <img
                            src="/assets/icons/menus/transactions.svg"
                            alt="defi balance menu"
                            className="transaction-img"
                          />
                          <div
                            className="transaction-summary-text"
                            onClick={() => detailTransaction(item?.tx_hash)}
                          >
                            <div className="accordion-header">
                              {capitalizeFirstLetter(item?.name) || 'Transaction'}
                            </div>

                            <div className="accordion-sub-header">
                              {getDateTimeFromTimestampAltFromat(item?.time_at)}
                            </div>
                          </div>
                        </div>
                        <div style={{ display: 'flex', width: '18ch' }}>
                          <img
                            src={getChainInfo(item.chain)?.logo_url || item?.chain_logo}
                            alt="defi balance menu"
                            style={{ width: '30px', height: '30px' }}
                            // className="chain-img"
                          />
                          <div
                          //  className="transaction-summary-text2"
                          >
                            <div className="accordion-summary-date">
                              <WalletAddressEllipsis
                                text={capitalizeFirstLetter(item?.name) || 'Transaction'}
                                maxTextCount={10}
                              />
                            </div>
                            <div className="accordion-summary-date">
                              {capitalizeFirstLetter(getChainInfo(item.chain)?.label || '')}
                            </div>
                          </div>
                        </div>
                        <div className="transaction-summary-text2">
                          <div className="accordion-summary-gas">Eth Gas</div>
                          <div className="accordion-summary-date">
                            {getSubParts(item?.eth_gas_fee) || 'N/A'}
                          </div>
                        </div>
                        <div className="transaction-summary-text2">
                          <div className="accordion-summary-gas">USD Gas</div>
                          <div className="accordion-summary-date">
                            {getSubParts(item?.usd_gas_fee) || 'N/A'}
                          </div>
                        </div>
                        {/* </div> */}
                      </div>
                    }
                  >
                    {/* <div style={{
                    boxShadow: 'rgb(0 0 0 / 15%) 0px 5px 5px 0px'
                  }}>
                    {
                      item.details && item.details.map((detail) => (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-around',
                            paddingTop: '10px',
                            borderTop: '1px solid #e5e5e5'
                          }}
                          className="transaction-card"
                        >

                        </div>

                      ))
                    }
                  </div> */}
                    {item?.transactions.map((data) => (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          width: '100%',
                          padding: '10px 80px 10px 50px',
                          borderTop: '1px solid #e5e5e5',
                        }}
                        className="transaction-card"
                      >
                        <div className="accordion-details">
                          <div>
                            <p className="details-title">
                              {data.type === 'send' ? 'To ' : 'From '} Address
                            </p>
                            <p className="details-accordion-data">
                              {data.type === 'send' && (
                                <div title={data?.to_addr} style={{ cursor: 'pointer' }}>
                                  {data?.to_addr_name ? (
                                    data.to_addr_name.length < 20 ? (
                                      data.to_addr_name
                                    ) : (
                                      <WalletAddressEllipsis
                                        text={data.to_addr.replace(/<[^>]*>?/gm, '')}
                                        maxTextCount={20}
                                      />
                                    )
                                  ) : (
                                    'N/A'
                                  )}
                                </div>
                              )}
                              {data.type === 'receive' && (
                                <div title={data?.from_addr} style={{ cursor: 'pointer' }}>
                                  {data?.from_addr_name ? (
                                    data.from_addr_name.length < 20 ? (
                                      data.from_addr_name
                                    ) : (
                                      <WalletAddressEllipsis
                                        text={data.from_addr.replace(/<[^>]*>?/gm, '')}
                                        maxTextCount={20}
                                      />
                                    )
                                  ) : (
                                    'N/A'
                                  )}
                                </div>
                              )}
                              {data.type === 'token approve' && (
                                <div title={data?.spender} style={{ cursor: 'pointer' }}>
                                  {data?.spender_name ? (
                                    data.spender_name.length < 20 ? (
                                      data.spender_name
                                    ) : (
                                      <WalletAddressEllipsis
                                        text={data.spender_name.replace(/<[^>]*>?/gm, '')}
                                        maxTextCount={20}
                                      />
                                    )
                                  ) : (
                                    'N/A'
                                  )}
                                </div>
                              )}
                            </p>
                          </div>
                          <div className="accordion-details">
                            <div>
                              <p className="details-title">Type</p>
                              <p className="details-accordion-data">{data?.type || 'N/A'}</p>
                            </div>
                          </div>
                        </div>
                        <div className="accordion-details">
                          <div>
                            <p className="details-title">Token</p>
                            <p className="details-accordion-data">
                              {data.token_id ? (
                                <div style={{ cursor: 'pointer' }} title={data?.token_id}>
                                  <WalletAddressEllipsis
                                    text={data?.token_name.replace(/<[^>]*>?/gm, '')}
                                    maxTextCount={20}
                                  />
                                </div>
                              ) : (
                                '--'
                              )}
                            </p>
                          </div>
                          <div
                            style={{
                              marginTop: '10px',
                            }}
                          >
                            <p className="details-title">Amount</p>
                            <p className="details-accordion-data">$ {data?.amount || 'N/A'}</p>
                          </div>
                        </div>
                        {/* <div className="accordion-details">
                          <div>
                            <p className="details-title">Account</p>
                            <p className="details-data">
                              <a href={`/defi/${data?.account}/overview`}>{data?.account}</a>
                            </p>
                          </div>
                          <div
                            style={{
                              marginTop: '10px',
                            }}
                          >
                            <p className="details-title">Chain</p>
                            <p className="details-data">{data?.chain}</p>
                          </div>
                        </div> */}
                      </div>
                    ))}
                  </AccordionPanel>
                );
              })}
            </Accordion>
          </IconSettings>
        ) : (
          'No transactions data.'
        )}
        <div
          style={{
            paddingTop: '0.5rem',
            float: 'right',
            paddingRight: '20px',
          }}
        >
          <Button
            className="modal-cancel-button"
            key="Show more"
            label="Show more"
            onClick={(e) => navigateToTransaction(e)}
          />
        </div>
      </div>
    </div>
  );
};

export default Transaction;
